import { Button } from '#app/components/ui/button'
import { Icon } from '#app/components/ui/icon'

interface TodoRiesgoConstruccionConfirmationScreenProps {
	onBack: () => void
	onClose: () => void
	data: {
		nombreContacto: string
		email: string
		tituloContrato: string
		ubicacionObra: string
	}
}

export function TodoRiesgoConstruccionConfirmationScreen({
	onBack,
	onClose,
	data,
}: TodoRiesgoConstruccionConfirmationScreenProps) {
	const handleWhatsAppContact = () => {
		const message = `Hola, envié una cotización de Seguro Todo Riesgo Construcción para el proyecto: ${data.tituloContrato}`
		const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(message)}`
		window.open(whatsappUrl, '_blank')
	}

	return (
		<div className="flex h-full w-full flex-col">
			<div className="flex-1 overflow-y-auto">
				<div className="flex w-full flex-col gap-3">
					<div className="flex w-full flex-col items-center gap-3 text-center text-blue-800">
						<h1 className="font-parkinsans text-3xl leading-10 font-medium">
							¡Solicitud enviada!
						</h1>
						<p className="font-inter text-base leading-6 font-normal">
							Recibimos tu cotización de Seguro Todo Riesgo Construcción. Un
							asesor especializado se pondrá en contacto pronto.
						</p>
					</div>

					<div className="w-full rounded-2xl border border-neutral-300 bg-neutral-50">
						<div className="p-4">
							<div className="flex flex-col gap-4 rounded-xl bg-neutral-100 p-3">
								<div className="font-inter flex flex-col gap-1 text-sm leading-5 text-neutral-700">
									<p className="mb-2 font-semibold text-blue-800">
										Resumen de la solicitud:
									</p>
									<p>
										<span className="font-medium">Contacto: </span>
										{data.nombreContacto}
									</p>
									<p>
										<span className="font-medium">Email: </span>
										{data.email}
									</p>
									<p>
										<span className="font-medium">Proyecto: </span>
										{data.tituloContrato}
									</p>
									<p>
										<span className="font-medium">Ubicación: </span>
										{data.ubicacionObra}
									</p>
								</div>
							</div>

							<div className="mt-3 rounded-xl bg-orange-50 p-3">
								<p className="font-inter text-sm text-orange-800">
									<span className="font-semibold">Tipo:</span> Seguro Todo
									Riesgo Construcción
								</p>
								<p className="font-inter text-sm text-orange-800">
									<span className="font-semibold">Estado:</span> Pendiente de
									cotización
								</p>
							</div>
						</div>
					</div>

					<div className="flex w-full items-center gap-4 rounded-2xl bg-green-50 px-4 py-3">
						<Icon
							name="natural-food"
							className="size-6 shrink-0 text-green-500"
						/>
						<div className="font-inter flex-1 text-blue-800">
							<p className="mb-0 text-base leading-6 font-bold">
								Gracias por ser parte de este propósito
							</p>
							<p className="text-sm leading-5">
								Con la contratación de tu póliza estarás aportando a una acción
								de impacto ambiental.
							</p>
						</div>
					</div>

					<div className="flex w-full items-center gap-4">
						<button
							onClick={handleWhatsAppContact}
							className="bg-success-500 flex shrink-0 items-center justify-center rounded-full p-3 transition-opacity hover:opacity-90"
							aria-label="Contactar por WhatsApp"
						>
							<Icon name="envelope-closed" className="size-5 text-white" />
						</button>
						<p className="font-inter flex-1 text-sm leading-5 text-blue-800">
							Recuerda que también puedes terminar de gestionar tu cobertura a
							través de nuestro Whatsapp.
						</p>
					</div>
				</div>
			</div>

			<div className="flex w-full shrink-0 flex-col items-center justify-start gap-2 bg-white pt-4 md:flex-row md:justify-between md:bg-transparent md:pt-8">
				<Button
					variant="primary"
					appearance="text"
					size="l"
					onClick={onBack}
					className="order-2 w-full gap-2 rounded-xl px-4 py-3 text-sm leading-4 md:order-1 md:w-auto md:px-6 md:py-4 md:text-base md:leading-5"
				>
					<Icon name="arrow-left" className="size-4" />
					Nueva cotización
				</Button>
				<Button
					variant="secondary"
					appearance="solid"
					size="l"
					onClick={onClose}
					className="order-1 w-full md:order-2 md:w-auto"
				>
					Cerrar
				</Button>
			</div>
		</div>
	)
}
